export const HeadersTooltips: Record<string, string> = {
  DBL: "Check deformation at beam level",
  zt: "Deflection at mast top",
  DML: "Check deformation",
  ft: "Tensions",
  BT: "Buckling and tilt check",
};